export const environment = {
  name: "angola",
  apiURL: "https://rhmobile.rhello.ao/",
  apiHost: "https://rhapi.rhello.ao",
  clientIdGapp: 36,
  urlGaap: "https://anestesiagaap.azurewebsites.net/login",
  VERSION: require("../../package.json").version,
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts